import React from 'react';
import { Card, Skeleton } from 'antd';
import { SkHeader, SkStatCards, SkTabsBar, SkAlertBanner } from './_primitives';

/** CommunicationPage — 4 template stats, 4 tabs (Email/SMS/Push/InApp), template cards grid */
const CommunicationPageLoader = () => (
  <div className="w-full p-4 md:p-6">
    <SkHeader actions={1} />
    <SkAlertBanner />
    <SkStatCards count={4} />
    <Card className="shadow-sm">
      <SkTabsBar tabs={4} />
      {/* Template cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {Array.from({ length: 6 }).map((_, i) => (
          <Card key={i} className="shadow-sm">
            <div className="flex items-start gap-3 mb-3">
              <Skeleton.Avatar active size="large" shape="square" />
              <div className="flex-1">
                <Skeleton.Input active size="small" style={{ width: '70%', marginBottom: 6 }} />
                <Skeleton.Input active size="small" style={{ width: '50%' }} />
              </div>
            </div>
            <Skeleton active paragraph={{ rows: 2 }} title={false} />
            <div className="flex gap-2 mt-3">
              <Skeleton.Button active size="small" style={{ width: 70 }} />
              <Skeleton.Button active size="small" style={{ width: 70 }} />
            </div>
          </Card>
        ))}
      </div>
    </Card>
  </div>
);

export default CommunicationPageLoader;
